// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Y0hwr","label":"styles_label__2FA54"};